import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Ref, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordSuccessView',
  emits: ['loginSubmitted', 'errorCatched'],
  setup(__props, { emit: __emit }) {

const activateLoginRedirect: Ref<boolean> = ref(true)
const emit = __emit

const loginSubmitted = () => {
  window.localStorage.removeItem('email')
  window.localStorage.removeItem('provider')
  activateLoginRedirect.value = false
  emit('loginSubmitted')
}

window.setTimeout(function () {
  if (activateLoginRedirect.value) {
    loginSubmitted()
  }
}, 5000)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Your password was updated successfully!", -1)),
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode("Please wait while we log you in with your new password. Or ", -1)),
      _createElementVNode("a", {
        onClick: loginSubmitted,
        href: "#"
      }, "click here"),
      _cache[1] || (_cache[1] = _createTextVNode(" to do it now.", -1))
    ])
  ], 64))
}
}

})